@if (incidentType) {
  <div class="side-menu" >
    <div style="margin:30px 20px 20px 20px; border-bottom:1px solid lightgrey;">
      <ion-text>
        <h3 style="font-weight:600; font-size: 18px; margin-bottom:5px; color: black;"> {{incidentType.name}} <ion-chip [style.color]="incidentType.color" [style.background-color]="incidentType.color + '30'"><b>{{incidentType.key}}</b></ion-chip>
      </h3>
    </ion-text>
    <ion-text color="dark" style="font-size:14px; display:inline-block; margin-bottom:5px;">Version: <span style="font-weight:500">{{incidentModel.versionNumber + 1}}</span></ion-text> &nbsp; @if (incidentType.activeModel.versionNumber == (incidentType.modelVersions.length - 1)) {
    <ion-text color="dark" style="font-size:14px; display:inline-block; margin-bottom:5px;">Status: <span style="font-weight:500">Active</span> </ion-text>
  }
  @if (incidentType.activeModel.versionNumber != (incidentType.modelVersions.length - 1)) {
    <ion-text color="dark" style="font-size:14px; display:inline-block; margin-bottom:5px;">Status: <span style="font-weight:500">Draft</span> </ion-text>
  }
  <ion-text color="dark" style="font-size:14px;display:block; margin-bottom:15px;">Updated: {{incidentModel.created | date:dateFormat }}</ion-text>
  <!--ion-text>
  <p><b>Description:</b> {{incidentType.description}}</p>
</ion-text>
<ion-text>
  <p><b>Version:</b> {{incidentType.modelVersions.length}} &nbsp;&nbsp;&nbsp;<b>Status:</b> <ion-text
*ngIf="incidentType.activeModel.versionNumber == (incidentType.modelVersions.length - 1)"> Active</ion-text> <ion-text
*ngIf="incidentType.activeModel.versionNumber != (incidentType.modelVersions.length - 1)"> Draft</ion-text></p>
</ion-text-->
</div>
<ion-list>
  <ion-item  [routerLink]="['/config/incident-type/', id]" lines="none" >
    <ion-icon slot="start" name="hammer"></ion-icon>
    <ion-label  style="font-weight:500">Form Layout</ion-label>
  </ion-item>
  <ion-item  [routerLink]="['/config/incident-type/',id, 'optional-forms']" lines="none" >
    <ion-icon slot="start" name="hammer"></ion-icon>
    <ion-label  style="font-weight:500">Optional Forms</ion-label>
  </ion-item>
  <ion-item [routerLink]="['/config/incident-type/', id, 'workflow']" button lines="none">
    <ion-icon slot="start" name="return-down-forward"></ion-icon>
    <ion-label style="font-weight:500">Workflow</ion-label>
  </ion-item>
  <ion-item [routerLink]="['/config/incident-type/', id, 'attributes']" button lines="none">
    <ion-icon slot="start" name="link-outline"></ion-icon>
    <ion-label style="font-weight:500">Attributes</ion-label>
  </ion-item>
  <ion-item [routerLink]="['/config/incident-type/', id, 'permissions']" lines="none">
    <ion-icon slot="start" name="people"></ion-icon>
    <ion-label style="font-weight:500">Access</ion-label>
  </ion-item>
  <ion-item [routerLink]="['/config/incident-type/', id, 'reports']" lines="none">
    <ion-icon slot="start" name="documents-outline"></ion-icon>
    <ion-label style="font-weight:500">Reports</ion-label>
  </ion-item>
  <ion-item [routerLink]="['/config/incident-type/', id, 'notifications']" lines="none">
    <ion-icon slot="start" name="alarm-outline"></ion-icon>
    <ion-label style="font-weight:500">Notifications</ion-label>
  </ion-item>
  @if (incidentTypeService.axessScanEnabled) {
    <ion-item [routerLink]="['/config/incident-type/', id, 'integrations']" lines="none">
      <ion-icon slot="start" name="link-outline"></ion-icon>
      <ion-label style="font-weight:500">Integrations</ion-label>
    </ion-item>
  }
  <ion-item [routerLink]="['/config/incident-type/', id, 'versions']" lines="none">
    <ion-icon slot="start" name="documents-outline"></ion-icon>
    <ion-label style="font-weight:500">Versions</ion-label>
  </ion-item>
</ion-list>
<!--div style="height:100px">
<ion-buttons style="padding:25px 50px; float: right">
  <ion-button color="primary" fill="solid" *ngIf="incidentType.activeModel.versionNumber != (incidentType.modelVersions.length - 1)" (click)="saveForm()" size="small"
  slot="end">Save</ion-button>
  <ion-button color="primary" [disabled]="dirty" fill="solid" *ngIf="incidentType.activeModel.versionNumber != (incidentType.modelVersions.length - 1)" size="small" slot="end"
  (click)="publish()">Publish</ion-button>
  <ion-button color="primary" fill="solid" *ngIf="incidentType.activeModel.versionNumber == (incidentType.modelVersions.length - 1)" size="small" slot="end"
  (click)="createVersion()">New Version +</ion-button>
</ion-buttons>
</div-->
</div>
}
<ion-router-outlet  style="margin-left:275px;"></ion-router-outlet>

